// extracted by mini-css-extract-plugin
export var bodySections = "_cc-8";
export var gray = "_cc-7";
export var green = "_cc-4";
export var iconContainer = "_cc-9";
export var iconWidgetContainer = "_cc-1";
export var phoneIcon = "_cc-2";
export var red = "_cc-5";
export var statusDot = "_cc-3";
export var widgetContainer = "_cc-0";
export var yellow = "_cc-6";